"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PasswordDenied: ['password-denied', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v6', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.5 14.999L15 19.499', 'M15 14.999L19.5 19.499', 'M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375']],
  PasswordCursor1: ['password-cursor-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v9a1.5,1.5,0,0,1-1.5,1.5', 'M13.1,13.461,16,22.723a.751.751,0,0,0,1.218.334L18.75,18.75l4.252-.9a.75.75,0,0,0-.185-1.237l-8.683-4.053A.75.75,0,0,0,13.1,13.461Z', 'M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375']],
  PasswordDesktopApproved: ['password-desktop-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,18.75a8.934,8.934,0,0,0,1.5,4.5H9a8.934,8.934,0,0,0,1.5-4.5', 'M6.75 23.25L17.25 23.25', 'M0.75 14.25L23.25 14.25', 'M0.750 0.750 L23.250 0.750 L23.250 18.750 L0.750 18.750 Z', 'M17.956 4.516L12 11.25 8.25 7.516']],
  PasswordDesktop: ['password-desktop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.875,7.875a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M11.625,7.875A.375.375,0,1,0,12,8.25a.374.374,0,0,0-.375-.375h0', 'M3.750 5.250 L20.250 5.250 L20.250 11.250 L3.750 11.250 Z', 'M15 8.25L16.5 8.25', 'M13.5,18.75a8.934,8.934,0,0,0,1.5,4.5H9a8.934,8.934,0,0,0,1.5-4.5', 'M6.75 23.25L17.25 23.25', 'M0.75 15.75L23.25 15.75', 'M0.750 0.750 L23.250 0.750 L23.250 18.750 L0.750 18.750 Z']],
  PasswordLock1: ['password-lock-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v6', 'M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75,19.154a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  TouchPasswordApproved: ['touch-password-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25 4.5L16.5 9 14.25 6.75', 'M3.75,12H2.25a1.5,1.5,0,0,1-1.5-1.5V3a1.5,1.5,0,0,1,1.5-1.5h19.5A1.5,1.5,0,0,1,23.25,3v7.5a1.5,1.5,0,0,1-1.5,1.5h-9', 'M5.25,22.5,2.486,19.39a1.557,1.557,0,1,1,2.327-2.069L6.75,19.5v-9a1.5,1.5,0,0,1,3,0v6.75h1.5a4.5,4.5,0,0,1,4.5,4.5V22.5']],
  PasswordLock: ['password-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6,10.875a.375.375,0,1,0,.375.375A.374.374,0,0,0,6,10.875H6', 'M9.75,6.75V4.5A3.761,3.761,0,0,0,6,.75H6A3.76,3.76,0,0,0,2.25,4.5V6.75', 'M17.25 20.25L20.25 20.25', 'M8.250 15.750 L23.250 15.750 L23.250 23.250 L8.250 23.250 Z', 'M14.25 18.75L14.25 20.25', 'M11.25 18.75L11.25 20.25', 'M11.25,12.75V8.25a1.5,1.5,0,0,0-1.5-1.5H2.25a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h3']],
  PasswordLock2: ['password-lock-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.250 10.500 L23.250 10.500 L23.250 18.000 L14.250 18.000 Z', 'M15.75,10.5V9a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v1.5', 'M18.75,13.875a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M4.125,13.875a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M7.875,13.875a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M11.25,18h-9a1.5,1.5,0,0,1-1.5-1.5v-6A1.5,1.5,0,0,1,2.25,9h9']],
  TouchPasswordLock: ['touch-password-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3,12H2.25a1.5,1.5,0,0,1-1.5-1.5V3a1.5,1.5,0,0,1,1.5-1.5h10.5', 'M5.25,22.5,2.486,19.39a1.557,1.557,0,1,1,2.327-2.069L6.75,19.5v-9a1.5,1.5,0,0,1,3,0v6.75h1.5a4.5,4.5,0,0,1,4.5,4.5V22.5', 'M14.250 6.000 L23.250 6.000 L23.250 13.500 L14.250 13.500 Z', 'M18.75,1.5h0a3,3,0,0,0-3,3V6h6V4.5A3,3,0,0,0,18.75,1.5Z', 'M18.75,9.4a.375.375,0,1,1-.375.375A.375.375,0,0,1,18.75,9.4']],
  PasswordDesktopLock: ['password-desktop-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.125,7.875A.375.375,0,1,0,7.5,8.25a.374.374,0,0,0-.375-.375h0', 'M10.875,7.875a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375h0', 'M11.25,11.25H4.5a.75.75,0,0,1-.75-.75V6a.75.75,0,0,1,.75-.75h6.75', 'M13.5,18.75a8.934,8.934,0,0,0,1.5,4.5H9a8.934,8.934,0,0,0,1.5-4.5', 'M6.75 23.25L17.25 23.25', 'M0.75 15.75L23.25 15.75', 'M23.25,15.75v1.5a1.5,1.5,0,0,1-1.5,1.5H2.25a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h10.5', 'M14.250 5.250 L23.250 5.250 L23.250 12.750 L14.250 12.750 Z', 'M15.75,5.25V3.75a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v1.5', 'M18.75,8.625A.375.375,0,1,0,19.125,9a.374.374,0,0,0-.375-.375h0']],
  PasswordApproved: ['password-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v6', 'M23.25,17.25a6,6,0,1,1-6-6', 'M23.25,12.749l-5.47,5.47a.749.749,0,0,1-1.06,0L15,16.5', 'M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375', 'M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375']],
  PasswordDesktopLockApproved: ['password-desktop-lock-approved', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M13.5,18.75a8.934,8.934,0,0,0,1.5,4.5H9a8.934,8.934,0,0,0,1.5-4.5', 'M6.75 23.25L17.25 23.25', 'M0.75 15.75L23.25 15.75', 'M23.25,15.75v1.5a1.5,1.5,0,0,1-1.5,1.5H2.25a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h10.5', 'M14.250 5.250 L23.250 5.250 L23.250 12.750 L14.250 12.750 Z', 'M15.75,5.25V3.75a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v1.5', 'M18.75,8.625A.375.375,0,1,0,19.125,9a.374.374,0,0,0-.375-.375h0', 'M10.5 6.75L6.75 11.25 4.5 9']],
  PasswordKey: ['password-key', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.236 19.744 A3.000 3.000 0 1 0 17.236 19.744 A3.000 3.000 0 1 0 11.236 19.744 Z', 'M16.357 17.622L21.66 12.319 23.251 13.91', 'M19.539 14.44L20.6 15.501', 'M23.251,9.244V2.494a1.5,1.5,0,0,0-1.5-1.5H2.251a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5H7.5', 'M0.751 5.494L23.251 5.494']],
  PasswordType: ['password-type', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 14.25L20.25 14.25', 'M0.750 6.750 L23.250 6.750 L23.250 17.250 L0.750 17.250 Z', 'M7.5 10.5L3.75 14.25', 'M7.5 14.25L3.75 10.5', 'M14.25 10.5L10.5 14.25', 'M14.25 14.25L10.5 10.5']]
};
exports["default"] = _default;